"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var AffilatesOffersListCtl = /** @class */ (function (_super) {
    __extends(AffilatesOffersListCtl, _super);
    function AffilatesOffersListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_affilate_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.affilate_id; });
        _this.dk_affilate_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.affilate_title; });
        _this.dk_offer_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.offer_id; });
        _this.dk_offer_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.offer_title; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_is_deprecated = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_deprecated; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    AffilatesOffersListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    AffilatesOffersListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "pprogram offer with id [" + id + "] not found !";
    };
    AffilatesOffersListCtl.prototype.LoadData = function (affilateId, onDone) {
        var _this = this;
        webAApi_1.ListPProgramPublicOffersByPProgramIdGet.exec({ pprogram_id: affilateId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    offer_id: resp.list[i].pprogram_offer_id,
                    offer_title: resp.list[i].pprogram_offer_title,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    affilate_id: resp.list[i].pprogram_id,
                    affilate_title: resp.list[i].pprogram_title,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    is_deprecated: resp.list[i].is_deprecated
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AffilatesOffersListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPProgramPublicOffer.exec({
            data: {
                offer_id: data.offer_id,
                pprogram_id: data.affilate_id,
                is_deprecated: data.is_deprecated
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                offer_id: data.offer_id,
                offer_title: resp.offer_title,
                date_changed2: moment(resp.date_added_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                affilate_id: data.affilate_id,
                affilate_title: resp.pprogram_title,
                brand_title: resp.brand_title,
                brand_id: resp.brand_id,
                is_deprecated: data.is_deprecated
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    /*public EditData(data: IEditAffilateOfferItem, onDone?: () => void) {
        let _tmp = this.getById(data.key);
        if (_tmp) {
            DoEditPProgramPublicOffer.exec({
                data: {
                    pprogram_public_offer_id: data.key,
                    brand_offer_id: data.offer_id,
                    is_deprecated: data.is_deprecated
                }
            }, (resp: DoEditPProgramPublicOfferResponse) => {

                _tmp.offer_id = data.offer_id;
                _tmp.offer_title = resp.pprogram_offer_title;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.is_deprecated = data.is_deprecated;

                this.Update();
                if (onDone) {
                    onDone();
                }

            }, (err) => {
                this._errDialog.ShowApiError(err);
            });
        }
    }*/
    AffilatesOffersListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    AffilatesOffersListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePProgramPublicOffer.exec({
                data: {
                    pprogram_public_offer_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AffilatesOffersListCtl.prototype.DoSetIsDeprecated = function (key, isDeprecated, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPProgramPublicOfferIsDeprecated.exec({ data: { pprogram_offer_id: key, is_deprecated: isDeprecated } }, function (resp) {
                _tmp.is_deprecated = isDeprecated;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return AffilatesOffersListCtl;
}(BaseController_1.BaseController));
exports.AffilatesOffersListCtl = AffilatesOffersListCtl;
/*export interface IEditAffilateOfferItem {

    key: number;

    offer_id: number;

    is_deprecated: boolean;

}*/ 



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ctl/options/AffilatesOffersListCtl.ts
// module id = 961
// module chunks = 0